export default __webpack_public_path__ + "9c40906379131f3851f29b5751ec9979.png";